import { Component } from '@angular/core';
import { LoginService } from './services/login.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent{
  public static readonly title = 'SOCIABLE';
  public opened: boolean = false;
  public static breadcrumb = 'sociable'
  public static breadcrumbRedirect = ''
  public static view = ''

  constructor (public loginService:LoginService, public router: Router) {}

  public static updateAppHeader(view: string, breadcrumb: string = '', breadcrumbRedirect: string = ''): void{
    AppComponent.view = view
    AppComponent.breadcrumb = breadcrumb
    AppComponent.breadcrumbRedirect = breadcrumbRedirect
  }

  public getBreadCrumb(): string{
    return AppComponent.breadcrumb
  }

  public redirectToBreadcrumb(): void {
    if(!!AppComponent.breadcrumb && !!AppComponent.breadcrumbRedirect){
      this.router.navigate([AppComponent.breadcrumbRedirect])
    }
  }

  public getBreadcrumbRedirect(): string{
    return AppComponent.breadcrumbRedirect
  }

  public getView(): string{
    return AppComponent.view
  }

  public isAuthenticated (): boolean {
    return this.loginService.isAuthenticated()
  }

  public isAdmin (): boolean {
    return this.loginService.isAdmin()
  }

  public askLogout (): void {
    this.loginService.logout()
  }
}
